import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = () => {
      try {
        const storedToken = localStorage.getItem('buniverse_token');
        const storedUser = localStorage.getItem('buniverse_user');

        // If nothing is there, we are logged out.
        if (!storedToken || !storedUser || storedUser === 'undefined') {
          throw new Error("No valid session");
        }

        const parsedUser = JSON.parse(storedUser);
        setToken(storedToken);
        setUser(parsedUser);
      } catch (e) {
        // If anything fails, SHRED the storage
        localStorage.clear();
        setToken(null);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    initAuth();
  }, []);

  const login = (newToken, userData) => {
    // 1. Save to LocalStorage first
    localStorage.setItem('buniverse_token', newToken);
    localStorage.setItem('buniverse_user', JSON.stringify(userData));
    
    // 2. Then update React state
    setToken(newToken);
    setUser(userData);
    
    console.log("Context updated. Current state:", userData);
  };

  const logout = () => {
    localStorage.clear();
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, isAuthenticated: !!token, login, logout, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};